import toPairs from 'lodash/toPairs'
import isArray from 'lodash/isArray'
import { flattenObject } from './flatten-object'

export function parseErrorMessages(error: unknown): string[] {
  if (!error) {
    return []
  }

  if (typeof error === 'string') {
    return [error]
  }

  if (error instanceof Error) {
    return [error.message]
  }

  const flattenErrorObj = flattenObject(error)

  return toPairs(flattenErrorObj).map(([k, v]) => `${k}: ${isArray(v) ? v.join(', ') : v}`)
}
